import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1996f515"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["d"]
const _hoisted_3 = ["width", "height", "viewBox"]
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "degree-number" }

import { computed } from "vue";
import { getChromaticScaleDegree } from "@/utils/noteUtils";
import { svgPaths } from "@/utils/svgPaths";
import type { Scale } from "@/types";

interface Props {
  chromaticInterval: number;
  scale?: Scale;
  size?: "small" | "medium" | "large";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScaleDegreeLabel',
  props: {
    chromaticInterval: {},
    scale: {},
    size: { default: "medium" }
  },
  setup(__props: any) {

const props = __props;

const scaleDegree = computed(() => {
  // Handle Locrian mode special case: ♯4 → ♭5
  if (props.scale?.name === "Locrian" && props.chromaticInterval === 6) {
    return "♭5";
  }
  
  return getChromaticScaleDegree(props.chromaticInterval);
});

const degreeNumber = computed(() => {
  return scaleDegree.value.replace(/[♯♭#b]/g, '');
});

const hasAccidental = computed(() => {
  return scaleDegree.value.includes('♯') || scaleDegree.value.includes('#') || 
         scaleDegree.value.includes('♭') || scaleDegree.value.includes('b');
});

const isSharp = computed(() => {
  return scaleDegree.value.includes('♯') || scaleDegree.value.includes('#');
});

const isFlat = computed(() => {
  return scaleDegree.value.includes('♭') || scaleDegree.value.includes('b');
});

// Dynamic sizing for SVG accidental symbols based on component size
const getAccidentalSize = computed(() => () => {
  switch (props.size) {
    case "small":
      return { width: 7, height: 13 }; // ~70% of original
    case "large":
      return { width: 9, height: 17 }; // ~130% of original
    case "medium":
    default:
      return { width: 7, height: 13 }; // Original size
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scale-degree-label", [
      `scale-degree-label--${_ctx.size}`,
      {
        'scale-degree-label--accidental': hasAccidental.value,
      },
    ]])
  }, [
    (isSharp.value)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: "degree-accidental degree-accidental--sharp",
          width: getAccidentalSize.value().width,
          height: getAccidentalSize.value().height,
          viewBox: _unref(svgPaths).sharp.viewBox
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(svgPaths).sharp.paths, (path, index) => {
            return (_openBlock(), _createElementBlock("path", {
              key: index,
              d: path.d,
              fill: "currentColor"
            }, null, 8, _hoisted_2))
          }), 128))
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (isFlat.value)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 1,
          class: "degree-accidental degree-accidental--flat",
          width: getAccidentalSize.value().width,
          height: getAccidentalSize.value().height,
          viewBox: _unref(svgPaths).flat.viewBox
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(svgPaths).flat.paths, (path, index) => {
            return (_openBlock(), _createElementBlock("path", {
              key: index,
              d: path.d,
              fill: "currentColor"
            }, null, 8, _hoisted_4))
          }), 128))
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_5, _toDisplayString(degreeNumber.value), 1)
  ], 2))
}
}

})